import React from "react"

import PageItem from "@components/PageItem"
import TileCarousel from "@components/TileCarousel/TileCarousel"
import { useRoutes } from "@hooks/useRoutes"
import { Box, Container, Heading } from "@chakra-ui/react"

export interface FeaturedPagesProps {
  title: string
  pages?: GatsbyTypes.SanityPageFlexible[]
  carouselSettings: GatsbyTypes.SanityCarouselSettings
}

const FeaturedPages = ({ title, pages, carouselSettings }: FeaturedPagesProps) => {
  const { urlResolver } = useRoutes()

  return (
    <Container py={4} pr={0}>
      <Heading mb={2.5} textAlign="center">
        {title}
      </Heading>
      {pages?.length && (
        <TileCarousel carouselSettings={carouselSettings}>
          {pages.map(page => (
            <Box mb={3.5} key={page?._key}>
              <PageItem title={page.title} description={page.description} link={urlResolver(page.url)} />
            </Box>
          ))}
        </TileCarousel>
      )}
    </Container>
  )
}

export default React.memo(FeaturedPages)
